<div class="loader" [ngStyle]="{ width: size + 'px', height: size + 'px' }">
  <svg class="circular" viewBox="25 25 50 50">
    <circle class="path" cx="50" cy="50" r="20"></circle>
  </svg>
</div>
